const SVGInvestorsBusinessDaily = () => (
  <svg
    width="128"
    height="86"
    viewBox="0 0 128 86"
    fill="none"
    style={{ width: '100%' }}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
  >
    <title>Investor's Business Daily logo</title>
    <path
      d="M13.1868 27.8758L14.8068 25.6268V10.8642L13.1868 8.61523H19.4355L17.8733 10.8642V25.6268L19.4355 27.8758H13.1868Z"
      fill="#14437A"
    />
    <path
      d="M31.1821 27.818C29.4464 24.877 24.2969 17.0921 24.2969 17.0921V27.818H21.9826V13.8051L20.3625 11.6138H23.8341L30.6614 21.8784V11.6138H32.9758V27.8756H31.1821"
      fill="#14437A"
    />
    <path
      d="M41.8275 27.8756H39.7446L34.8845 13.0554L33.843 11.6138H37.3724L41.0754 23.0893L44.2576 13.0554L43.274 11.6138H47.1505L41.8275 27.8756Z"
      fill="#14437A"
    />
    <path
      d="M56.5814 27.8756H48.5969V11.6138H57.0443L56.1764 13.7474H51.3741V18.476H56.0607L55.135 20.725H51.3741V25.5113H57.565L56.5814 27.8756Z"
      fill="#14437A"
    />
    <path
      d="M62.4808 28.2219C60.9764 28.2219 59.4143 27.9336 58.2571 27.3569L59.0092 24.8772C60.6872 26.4919 65.3158 26.4919 65.3158 23.8969C65.3158 20.4369 58.3149 20.7829 58.3149 15.593C58.3149 12.9403 60.34 11.3257 63.5222 11.3257C64.7373 11.3257 66.068 11.4987 67.1673 12.133L66.2995 14.555C65.1423 13.171 61.0922 13.0557 61.0922 15.3623C61.0922 18.361 68.0352 18.707 68.0352 23.2049C68.0352 26.0306 66.1259 28.2219 62.4808 28.2219Z"
      fill="#14437A"
    />
    <path
      d="M74.9799 13.7475V27.8758H72.2027V13.7475H67.9212L68.5576 11.6139H78.4515L79.2036 13.7475H74.9799Z"
      fill="#14437A"
    />
    <path
      d="M84.9885 28.1643C80.4177 28.1643 78.9133 23.205 78.9133 19.5143C78.9133 15.8237 80.8227 11.2681 85.1621 11.2681C89.7329 11.2681 91.2373 16.2274 91.2373 19.918C91.2373 23.6663 89.3858 28.1643 84.9885 28.1643ZM84.9885 13.517C82.1534 13.517 81.8063 17.3807 81.8063 19.399C81.8063 21.4173 82.2113 25.9153 85.1621 25.9153C87.9972 25.9153 88.3443 22.0516 88.3443 20.0333C88.4022 18.015 87.9393 13.517 84.9885 13.517Z"
      fill="#14437A"
    />
    <path
      d="M101.073 27.8756L96.097 20.6097V27.8756H93.3198V13.2861L92.1047 11.6138H98.1799C100.899 11.6138 103.04 13.4591 103.04 16.1694C103.04 18.5914 101.941 20.4367 99.4528 20.898L104.602 27.8756H101.073V27.8756ZM97.717 13.7474H96.097V19.0527H97.7749C99.1056 19.0527 100.263 18.0724 100.263 16.3424C100.321 14.8431 99.3949 13.7474 97.717 13.7474Z"
      fill="#14437A"
    />
    <path
      d="M104.429 16.6884C104.892 15.8811 105.123 14.9007 105.123 14.0358C104.082 13.9204 103.503 13.3438 103.503 12.5364C103.503 11.5561 104.197 11.0371 104.95 11.0371C105.818 11.0371 106.743 11.7291 106.743 13.2284C106.801 14.4394 105.991 15.9964 104.429 16.6884Z"
      fill="#14437A"
    />
    <path
      d="M112.125 28.2218C110.621 28.2218 109.059 27.9334 107.902 27.3568L108.654 24.8771C110.332 26.4918 114.96 26.4918 114.96 23.8968C114.96 20.4368 107.959 20.7828 107.959 15.5929C107.959 12.9402 109.984 11.3256 113.167 11.3256C114.382 11.3256 115.713 11.4986 116.812 12.1329L115.944 14.5549C114.787 13.1709 110.737 13.0555 110.737 15.3622C110.737 18.3608 117.68 18.7068 117.68 23.2048C117.622 26.0304 115.713 28.2218 112.125 28.2218Z"
      fill="#14437A"
    />
    <path
      d="M26.9553 52.845H20.4172L21.9216 50.769V35.6605L20.4172 33.5845H27.071C31.0054 33.5845 32.7412 35.8911 32.7412 38.3131C32.7412 40.7351 31.5261 42.2344 29.9639 42.6957C31.8733 43.1571 33.4933 45.0024 33.4933 47.309C33.5512 50.769 31.4104 52.845 26.9553 52.845ZM27.0131 35.7758H24.8724V41.7731H26.6081C28.6332 41.7731 29.7904 40.5044 29.7904 38.4861C29.8482 37.1021 28.9225 35.7758 27.0131 35.7758ZM27.476 44.0797H24.8724V50.4807H27.1867C29.3853 50.4807 30.5425 49.1544 30.5425 47.3667C30.6004 45.4637 29.3275 44.0797 27.476 44.0797Z"
      fill="#14437A"
    />
    <path
      d="M41.0725 53.0755C37.6009 53.0755 35.5759 50.9419 35.5759 46.7899V38.0247L34.5344 36.583H38.3531V46.7323C38.3531 49.3272 39.2788 50.7112 41.1882 50.7112C43.0397 50.7112 44.0811 49.3272 44.0811 46.8476V38.313L42.8082 36.583H46.569V46.9629C46.569 50.6536 44.7176 53.0755 41.0725 53.0755Z"
      fill="#14437A"
    />
    <path
      d="M52.3558 53.1911C50.8514 53.1911 49.2893 52.9028 48.1321 52.3261L48.8842 49.8465C50.5622 51.4611 55.1908 51.4611 55.1908 48.8662C55.1908 45.4062 48.1899 45.7522 48.1899 40.5622C48.1899 37.9096 50.215 36.2949 53.3972 36.2949C54.6123 36.2949 55.943 36.4679 57.0423 37.1022L56.1745 39.5242C55.0173 38.1402 50.9672 38.0249 50.9672 40.3316C50.9672 43.3302 57.9102 43.6762 57.9102 48.1742C57.8524 50.9998 55.943 53.1911 52.3558 53.1911Z"
      fill="#14437A"
    />
    <path d="M60.051 52.8449V38.14L58.8938 36.583H62.8282V52.8449H60.051Z" fill="#14437A" />
    <path
      d="M75.5571 52.7872C73.8214 49.8462 68.6719 42.0613 68.6719 42.0613V52.7872H66.3576V38.7743L64.7375 36.583H68.2091L75.0364 46.8476V36.583H77.3508V52.7872H75.5571Z"
      fill="#14437A"
    />
    <path
      d="M88.807 52.8449H80.7646V37.448L80.1282 36.583H89.212L88.3441 38.7167H83.5418V43.4453H88.2284L87.3027 45.6943H83.5418V50.4806H89.7327L88.807 52.8449Z"
      fill="#14437A"
    />
    <path
      d="M94.7073 53.1911C93.203 53.1911 91.6408 52.9028 90.4836 52.3261L91.2358 49.8465C92.9137 51.4611 97.5424 51.4611 97.5424 48.8662C97.5424 45.4062 90.5415 45.7522 90.5415 40.5622C90.5415 37.9096 92.5666 36.2949 95.7488 36.2949C96.9638 36.2949 98.2946 36.4679 99.3939 37.1022L98.526 39.5242C97.3688 38.1402 93.3187 38.0249 93.3187 40.3316C93.3187 43.3302 100.262 43.6762 100.262 48.1742C100.204 50.9998 98.2946 53.1911 94.7073 53.1911Z"
      fill="#14437A"
    />
    <path
      d="M104.832 53.1911C103.328 53.1911 101.766 52.9028 100.609 52.3261L101.361 49.8465C103.039 51.4611 107.667 51.4611 107.667 48.8662C107.667 45.4062 100.667 45.7522 100.667 40.5622C100.667 37.9096 102.692 36.2949 105.874 36.2949C107.089 36.2949 108.42 36.4679 109.519 37.1022L108.651 39.5242C107.494 38.1402 103.444 38.0249 103.444 40.3316C103.444 43.3302 110.387 43.6762 110.387 48.1742C110.387 50.9998 108.477 53.1911 104.832 53.1911Z"
      fill="#14437A"
    />
    <path
      d="M44.8374 77.9876H38.2415L39.6879 75.7962V60.8607L38.2415 58.7271H44.4902C50.1604 58.7271 52.764 62.3024 52.764 67.9536C52.8219 74.4699 50.0446 77.9876 44.8374 77.9876ZM44.3166 60.976H42.8123V75.5656H44.6059C47.7882 75.5656 49.6396 73.3743 49.6396 68.1843C49.6396 63.571 47.9617 60.976 44.3166 60.976Z"
      fill="#14437A"
    />
    <path
      d="M62.1956 77.9874L60.9806 73.8354H56.2361L55.0211 77.9874H52.1282L57.4512 63.2825L56.8726 61.7832H60.1705L65.3778 78.0451H62.1956V77.9874ZM58.6084 65.9352L56.8147 71.7595H60.402L58.6084 65.9352Z"
      fill="#14437A"
    />
    <path d="M67.1721 77.9875V63.2826L66.0149 61.7256H69.9493V77.9875H67.1721Z" fill="#14437A" />
    <path
      d="M81.1722 77.9875H73.5349V62.4752L72.9563 61.7256H76.3121V75.6231H82.098L81.1722 77.9875Z"
      fill="#14437A"
    />
    <path
      d="M87.3644 71.1252V77.9875H84.5872V71.1828L80.1899 63.0519L79.2063 61.7256H82.62L86.2651 68.7032L89.2737 62.9942L88.348 61.7256H92.5717L87.3644 71.1252Z"
      fill="#14437A"
    />
  </svg>
);

// eslint-disable-next-line import/no-default-export
export default SVGInvestorsBusinessDaily;
